<template>
  <div class="mb-2 grid formgrid" v-if="showDetail === false">
    <div class="col p-fluid field pt-3">
      <Slider v-model="progress"></Slider>
    </div>
    <div class="col-2 md:col-1">
      <Button
        :icon="autoPlay ? 'pi pi-pause' : 'pi pi-play'"
        v-tooltip="`แสดงการเดินทาง`"
        :class="autoPlay ? 'p-button-warning' : 'p-button-success'"
        @click="togglePlay"
      ></Button>
    </div>
    <div class="col-12 mt-2">
      <l-map
        :center="mapCenter"
        :zoom="13"
        :bounds="mapBound"
        v-if="userLocations.length > 0 || customerLocationOnMap.length > 0"
        style="height: 80vh"
      >
        <l-tile-layer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        ></l-tile-layer>

        <l-control position="topright">
          <div
            class="bg-white border-rounded opacity-80 font-bold p-2"
            v-if="latestTime"
          >
            เวลา {{ formatDateTime(latestTime) }}
          </div>
        </l-control>

        <l-polyline :lat-lngs="routes" color="red"></l-polyline>

        <!-- <l-circle-marker
        v-for="(customerLocation, index) in customerLocationOnMap"
        :key="`k-${index}`"
        :lat-lng="[customerLocation.latitude, customerLocation.longitude]"
        :radius="2"
      ></l-circle-marker> -->
        <l-marker
          v-for="(customerLocation, index) in customerLocationOnMap"
          :key="`k-${index}`"
          :lat-lng="[customerLocation.latitude, customerLocation.longitude]"
        >
          <l-icon
            :icon-url="iconUrl(customerLocation)"
            :icon-size="dynamicSize"
            :icon-anchor="dynamicAnchor"
          ></l-icon>
          <l-tooltip>
            <div class="text-lg">
              ลำดับที่ : {{ customerLocation.sequence }}
            </div>
            <div>
              {{ customerLocation.customerName }} ({{
                customerLocation.customerNo
              }}
              )
            </div>
            <div v-if="customerLocation.deliverOn">
              จัดส่งเมื่อ : {{ formatDateTime(customerLocation.deliverOn) }}
            </div>
          </l-tooltip>
        </l-marker>
        <l-marker :lat-lng="truckPosition" v-if="truckPosition">
          <l-icon
            icon-url="icons/truck_icon.png"
            :icon-size="truckDynamicSize"
            :icon-anchor="truckDynamicAnchor"
          ></l-icon>
        </l-marker>

        <l-circle-marker
          v-for="(still, index) in stillPoints"
          :key="`s-${index}`"
          :lat-lng="[still.latitude, still.longitude]"
          :radius="still.minutes / 2"
          :color="still.minutes < 60 ? 'orange' : 'red'"
          :fill="true"
          :fill-color="still.minutes < 60 ? 'orange' : ''"
        >
          <l-tooltip>
            <div class="text-lg">จุดจอดนาน {{ still.minutes }} นาที</div>
            <div>
              เริ่ม {{ formatTime(still.start) }} จนถึง
              {{ formatTime(still.end) }}
            </div>
          </l-tooltip>
        </l-circle-marker>
      </l-map>
    </div>
    <!-- <div>{{ JSON.stringify(stillPoints) }}</div> -->
  </div>
  <div v-else>
    <div class="grid">
      <div class="col-12">
        <span class="p-float-label mt-5">
          <InputText
            id="searchString"
            class="p-inputtext-sm"
            v-model="searchString"
          ></InputText>
          <label for="searchString">ค้นหา</label>

          <!-- <InputText
            id="searchfilterString"
            class="p-inputtext-sm"
          ></InputText>
          <label for="searchfilterString">Delivery date</label> -->

          <Button
            icon="pi pi-download"
            class="p-button-sm p-button-success"
            label="Excel"
            @click="onDownloadExcel"
            :disabled="filteredCustomerLocations.length === 0"
          ></Button>
        </span>
        
        <!-- <Button
          icon="pi pi-download"
          class="p-button-sm p-button-success"
          label="Excel"
          @click="onDownloadExcel"
          :disabled="filteredCustomerLocations.data.length === 0"
        ></Button> -->


      </div>
      <div>* ค้นหาด้วย รหัสร้านค้า, ชื่อร้านค้า, รหัส Delivery Order</div>
      <div class="col-12">
        <DataTable :value="filteredCustomerLocations" sortMode="multiple"  class="p-datatable-sm">
          <template #empty="">ไม่พบข้อมูล</template>

          <Column field="deliveryDate" header="วันที่จัดส่ง" sortable>
            <template #body="props">
              <template v-if="props.data.deliveryDate">
                {{ formatDate(props.data.deliveryDate) }}
              </template>
              <template v-else>???</template>
            </template>
          </Column>
          <Column field="shipmentNo" header="เลขที่ Shipment" sortable>
            <template #body="props">
              {{ parseInt(props.data.shipmentNo) }}
            </template>
          </Column>
          <Column field="saleoffice" header="Sale office" sortable></Column>

          <Column field="customerNo" header="รหัสร้านค้า" sortable>
            <template #body="props">
              {{ parseInt(props.data.customerNo) }}
            </template>
          </Column>
          <Column field="customerName" header="ร้านค้า" sortable></Column>
          <Column
            field="deliveryNo"
            header="รหัส Delivery Order"
            sortable
          ></Column>
          <Column field="sequence" header="ลำดับการส่ง" sortable></Column>
          <Column field="deliverOn" header="ยืนยันการชำระเงิน" sortable>
            <template #body="props">
              <template v-if="props.data.deliverOn">
                {{ formatDateTime(props.data.deliverOn) }}
              </template>
              <template v-else>ยังไม่ได้จัดส่ง</template>
            </template>
          </Column>

          <Column field="checkin_dt" header="เวลา check in" sortable>
            <template #body="props">
              <template v-if="props.data.checkin_dt">
                {{ formatDateTime(props.data.checkin_dt) }}
              </template>
              <template v-else>ยังไม่ได้ check in</template>
            </template>
          </Column>
          <Column field="checkout_dt" header="เวลา check out" sortable>
            <template #body="props">
              <template v-if="props.data.checkout_dt">
                {{ formatDateTime(props.data.checkout_dt) }}
              </template>
              <template v-else>ยังไม่ได้ check out</template>
            </template>
          </Column>
          <Column field="serviceTime" header="เวลาที่ใช้" sortable>
            <template #body="props">
              <template v-if="props.data.checkout_dt">
                {{ props.data.serviceTime }} นาที
              </template>
            </template>
          </Column>

          <Column field="caseAmount" header="จำนวนลัง" sortable>
            <template #body="props">
              <template v-if="props.data.caseAmount">
                  {{ props.data.caseAmount }} ลัง
              </template>
            </template>
          </Column>

        </DataTable>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { usePlugin } from "@/plugins";
import { computed, defineComponent, onMounted, ref } from "vue";
import {
  LMap,
  LMarker,
  LTileLayer,
  LCircleMarker,
  LPolyline,
  LIcon,
  LTooltip,
  LControl,
} from "@vue-leaflet/vue-leaflet";
import {
  CustomerLocationDto,
  GetShipmentDirectionResponse,
  StillDto,
  UserLocation,
} from "@/types";
import { latLngBounds } from "leaflet";
import Fuse from "fuse.js";
import { saveAs } from "file-saver";
import { Workbook } from "exceljs";

export default defineComponent({
  name: "ShipmentMap",
  props: {
    shipmentNo: {
      type: String,
      required: true,
    },
    showDetail: {
      type: Boolean,
      default: false,
    },
    showmultipe: {
      type: Boolean,
      default: false,
    },
    shipmentList: {
      type: Array, // use PropType
      default: () => [], // use a factory function
    },
  },
  components: {
    LMap,
    LTileLayer,
    LIcon,
    LPolyline,
    LMarker,
    LTooltip,
    LControl,
    LCircleMarker,
  },
  setup(props) {
    const {
      success,
      axios,
      setLoading,
      error,
      formatDateTime,
      formatDate,
      formatTime,
      dayjs,
      distance,
    } = usePlugin();

    const customerLocations = ref<CustomerLocationDto[]>([]);
    const userLocations = ref<UserLocation[]>([]);

    const progress = ref(0);

    const loadMap = async () => {
      setLoading(true);
      try {
        if(props.showmultipe === true){
          console.log("getdata multiple shipmaent data");
          const result = await axios.post<GetShipmentDirectionResponse>(
            `api/v1/admin/shipment/mapd/detail`,
            {
              shipments: props.shipmentList
            }
          );
          console.log(result.data.customerLocations)
          customerLocations.value = result.data.customerLocations ?? [];
          userLocations.value =
            result.data.userLocations?.sort(
              (x, y) => dayjs(x.timestamp).unix() - dayjs(y.timestamp).unix()
            ) ?? [];
        }else{
            console.log("getdata single shipmaent data");
            const result = await axios.get<GetShipmentDirectionResponse>(
            `api/v1/admin/shipment/map/${props.shipmentNo}`
          );
          console.log(result.data.customerLocations)
          customerLocations.value = result.data.customerLocations ?? [];
          userLocations.value =
            result.data.userLocations?.sort(
              (x, y) => dayjs(x.timestamp).unix() - dayjs(y.timestamp).unix()
            ) ?? [];
        }

      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    const onDownloadExcel = async () => {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Data");
      worksheet.addTable({
        name: "Table1",
        ref: "A1",
        columns: [
          { name: "วันที่จัดส่ง" },
          { name: "เลขที่ Shipment" },
          { name: "Sale office" },
          { name: "รหัสร้านค้า" },
          { name: "ร้านค้า" },
          { name: "รหัส DO" },
          { name: "ลำดับการส่ง" },
          { name: "ยืนยันการชำระเงิน" },
          { name: "เวลา check in" },
          { name: "เวลา check out" },
          { name: "เวลาที่ใช้ (นาที)" },
          { name: "จำนวนลัง" },
        ],
        rows: filteredCustomerLocations.value.map((x) => {
          return [
            formatDate(x.deliveryDate),
            x.shipmentNo,
            x.saleoffice,
            x.customerNo,
            x.customerName,       
            x.deliveryNo,
            x.sequence,
            formatDateTime(x.deliverOn),
            formatDateTime(x.checkin_dt),
            formatDateTime(x.checkout_dt),
            x.serviceTime,
            x.caseAmount
          ];
        }),
      });
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer]);
      saveAs(blob, `shipment${props.shipmentNo}_${dayjs().format("YYYYMMDD-HHmmss")}.xlsx`);
    };
    
    const mapBound = computed(() => {
      let latitudes = customerLocations.value
        .filter((x) => !!x.latitude)
        .map((x) => x.latitude as number);
      let longitudes = customerLocations.value
        .filter((x) => !!x.longitude!)
        .map((x) => x.longitude as number);
      latitudes = [
        ...latitudes,
        ...userLocations.value
          .filter((x) => !!x.latitude)
          .map((x) => x.latitude as number),
      ];
      longitudes = [
        ...longitudes,
        ...userLocations.value
          .filter((x) => !!x.longitude!)
          .map((x) => x.longitude as number),
      ];

      latitudes.sort((a, b) => a! - b!);
      longitudes.sort((a, b) => a! - b!);
      // return {
      //   _northEast: { lat: latitudes[0], lng: longitudes[0] },
      //   _southWest: {
      //     lat: latitudes[latitudes.length - 1],
      //     lng: longitudes[longitudes.length - 1],
      //   },
      // };
      return latLngBounds([
        [latitudes[0], longitudes[0]],
        [latitudes[latitudes.length - 1], longitudes[longitudes.length - 1]],
      ]);
    });

    const average = (arr: number[]) =>
      arr.reduce((p, c) => p + c, 0) / arr.length;

    const mapCenter = computed(() => {
      let latitudes = customerLocations.value
        .filter((x) => !!x.latitude)
        .map((x) => x.latitude as number);
      let longitudes = customerLocations.value
        .filter((x) => !!x.longitude!)
        .map((x) => x.longitude as number);
      latitudes = [
        ...latitudes,
        ...userLocations.value
          .filter((x) => !!x.latitude)
          .map((x) => x.latitude as number),
      ];
      longitudes = [
        ...longitudes,
        ...userLocations.value
          .filter((x) => !!x.longitude!)
          .map((x) => x.longitude as number),
      ];

      if (latitudes.length === 0 || longitudes.length === 0) {
        return [6.95, 100.44];
      }
      return [average(latitudes), average(longitudes)];
    });

    const routes = computed(() => {
      return progressUserLocations.value.map((x) => {
        return [x.latitude, x.longitude];
      });
    });

    const customerLocationOnMap = computed(() => {
      return customerLocations.value.filter(
        (x) => (x.latitude ?? 0) > 0 && (x.longitude ?? 0) > 0
      );
    });

    const iconSize = 16;
    const dynamicSize = computed(() => {
      return [iconSize, iconSize * 1.25];
    });

    const dynamicAnchor = computed(() => {
      return [iconSize / 2, iconSize * 1];
    });

    const truckIconSize = 32;
    const truckDynamicSize = computed(() => {
      return [truckIconSize, truckIconSize * 1.25];
    });

    const truckDynamicAnchor = computed(() => {
      return [truckIconSize / 2, truckIconSize * 1];
    });

    const truckPosition = computed(() => {
      const location =
        progressUserLocations.value[progressUserLocations.value.length - 1];
      if (location) {
        return [location.latitude, location.longitude];
      } else {
        return null;
      }
    });

    const progressUserLocations = computed(() => {
      const progressIndex = (userLocations.value.length * progress.value) / 100;
      return userLocations.value.slice(0, progressIndex);
    });

    const latestTime = computed(() => {
      const location =
        progressUserLocations.value[progressUserLocations.value.length - 1];
      return location?.timestamp;
    });

    const autoPlay = ref(false);
    const togglePlay = () => {
      if (userLocations.value.length === 0) {
        error("ไม่พบข้อมูลการเดินทาง");
        return;
      }
      if (autoPlay.value) {
        autoPlay.value = false;
      } else {
        if (progress.value >= 100) {
          progress.value = 0;
        }
        autoPlay.value = true;
      }
    };

    const iconUrl = (customerDto: CustomerLocationDto) => {
      if (
        customerDto.deliverOn !== null &&
        latestTime.value &&
        dayjs(customerDto.deliverOn).diff(dayjs(latestTime.value), "seconds") <=
          0
      ) {
        return "icons/shop_done_icon.png";
      }

      return "icons/shop_icon.png";
    };

    const stillPoints = computed(() => {
      const result: StillDto[] = [];
      let startStill: Date | null = null;
      let endStill: Date | null = null;

      if (userLocations.value.length <= 1) {
        return result;
      }

      for (let i = 0; i < userLocations.value.length - 1; i++) {
        const thisLocation = userLocations.value[i];
        const nextLocation = userLocations.value[i + 1];
        let startStillLocation = null;
        if (startStillLocation === null) startStillLocation = thisLocation;

        const distanceBetween = distance(
          startStillLocation.latitude,
          startStillLocation.longitude,
          nextLocation.latitude,
          nextLocation.longitude,
          "m"
        );

        // if (distanceBetween <= 200) {
        //Still then capture start
        if (startStill === null) {
          startStill = thisLocation.timestamp;
        }
        // }

        if (distanceBetween > 50) {
          //Not still then calculate end
          endStill = thisLocation.timestamp;
          const minutes = dayjs(endStill).diff(startStill, "minutes");
          if (minutes > 30) {
            result.push({
              latitude: thisLocation.latitude,
              longitude: thisLocation.longitude,
              start: startStill!,
              end: endStill!,
              minutes: minutes,
            });
          }
          startStillLocation = null;
          startStill = null;
          endStill = null;
        }
      }

      return result;
    });

    const searchString = ref("");
    const filteredCustomerLocations = computed(() => {
      if (!searchString.value) return customerLocations.value;
      const fuse = new Fuse(customerLocations.value, {
        keys: ["customerNo", "customerName", "deliveryNo"],
        threshold: 0.3,
      });
      const result = fuse.search(searchString.value);
      return result.map((x) => x.item);
    });

    onMounted(() => {
      //Load location detail;
      loadMap();
      setInterval(() => {
        if (autoPlay.value) {
          progress.value = progress.value + 1;
          if (progress.value >= 100) {
            autoPlay.value = false;
          }
        }
      }, 300);
    });
    return {
      customerLocations,
      userLocations,
      mapBound,
      routes,
      mapCenter,
      customerLocationOnMap,
      progress,
      dynamicAnchor,
      dynamicSize,
      truckPosition,
      truckDynamicAnchor,
      truckDynamicSize,
      progressUserLocations,
      latestTime,
      formatDateTime,
      formatDate,
      togglePlay,
      iconUrl,
      autoPlay,
      stillPoints,
      formatTime,
      searchString,
      filteredCustomerLocations,
      onDownloadExcel,
    };
  },
});
</script>

<style scoped></style>